import * as React from "react";
import { Modal, ModalFooter } from "@grandvisionhq/common";
import { Util } from "@grandvisionhq/forms";
import { useDispatch, useSelector } from "@grandvisionhq/state";
import { useBaseSummarySlot } from "../../../../slots/summaries/slots/summaries/summary-context.js";
import { ShippingObjectTypes } from "../../../../state.js";
import { updateShippingDetails } from "../../../../StepShipping/StepShipping/actions.js";
import { getInvoiceFormData, getShippingData } from "../../../../StepShipping/StepShipping/selectors.js";
import { CheckoutForm } from "../../../../components/Forms/components/Forms/CheckoutForm.js";
import { FormFieldsWithCart } from "../../../../components/FormFieldsWithCart/components/FormFieldsWithCart/FormFieldsWithCart.js";
import { useIsFormSlotAvailable } from "../../../../slots/forms/slots/forms/form-context.js";
const EditableInvoiceSummary = ({ labels }) => {
  const isInvoiceFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.Invoice);
  const [invoiceFormData, setInvoiceFormData] = React.useState();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { Slots } = useBaseSummarySlot();
  const dispatch = useDispatch();
  const invoiceDetailsInitialData = useSelector(getInvoiceFormData);
  const invoiceShippingData = useSelector(getShippingData)?.invoice;
  const companyShippingData = useSelector(getShippingData)?.company;
  const invoiceData = {
    ...invoiceShippingData,
    secondaryEmail: invoiceShippingData?.secondaryEmail || companyShippingData?.secondaryEmail || "",
    recipientCode: invoiceShippingData?.recipientCode || companyShippingData?.recipientCode || ""
  };
  const hasData = invoiceData && !Object.values(invoiceData).every((x) => x === null || x === "");
  const InvoiceSummarySlot = Slots.invoice;
  if (!InvoiceSummarySlot && hasData) {
    console.error(
      "This opco is misconfigured. It has invoice data, but no invoice summary card setup."
    );
  }
  if (!InvoiceSummarySlot || !hasData) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isInvoiceFormAvailable && /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOpen: isModalOpen,
      onModalClose: () => setIsModalOpen(false),
      showIcon: true,
      footer: /* @__PURE__ */ React.createElement(
        ModalFooter,
        {
          ctaCaption: labels?.editModal?.save,
          onCta: () => {
            if (!invoiceFormData?.formValid) {
              Util.focusToTopErrorFieldOnScreen();
            } else {
              invoiceFormData && dispatch(updateShippingDetails({ form: invoiceFormData }));
              setIsModalOpen(false);
            }
          },
          onCancel: () => setIsModalOpen(false)
        }
      )
    },
    /* @__PURE__ */ React.createElement(
      CheckoutForm,
      {
        formName: "invoice",
        "data-t": "invoice",
        initialFormState: invoiceDetailsInitialData,
        onChange: (formData) => setInvoiceFormData(formData)
      },
      /* @__PURE__ */ React.createElement(FormFieldsWithCart, { formName: ShippingObjectTypes.Invoice })
    )
  ), hasData && /* @__PURE__ */ React.createElement(InvoiceSummarySlot, { actions: { onEdit: () => setIsModalOpen(true) }, values: invoiceData }));
};
export {
  EditableInvoiceSummary,
  EditableInvoiceSummary as default
};
//# sourceMappingURL=EditableInvoiceSummary.js.map
